<script setup>
// TODO: update this properly, since they've provided to use an SVG file already.
import { computed } from 'vue';

// eslint-disable-next-line no-undef
const props = defineProps({
    icon: String,
    width: {
        type: String,
        default: 'auto'
    },
    height: String,
    // Image path
    iconSrc: {
        type: [String, Object],
        required: false,
    },
});

const iconStyle = computed(() => ({
    width: props.width,
    height: props.height,
}));

const isImageSrc = computed(() => !!props.iconSrc);

const resolvedIcon = computed(() => {
    if (props.iconSrc) {
        return props.iconSrc;
    }

    return props.icon || null;
})
</script>

<template>
    <div :style="iconStyle" class="tw-flex tw-items-center">
        <img v-if="isImageSrc" :src="resolvedIcon" alt="" :style="iconStyle" />
        <!-- ??? -->
        <component v-else :is="resolvedIcon" :style="iconStyle" />
    </div>
</template>
